// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/InclusiveSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/InclusiveSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/InclusiveSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/InclusiveSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */

@font-face {
  font-family: "Inclusive Sans";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Inclusive Sans";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

#root,
#__next {
  isolation: isolate;
}

/* Battleship */

:root {
  --red-400: #ef5350;
  --blue-400: #42a5f5;
  --gray-100: #f5f5f5;
  --gray-400: #bdbdbd;
  --gray-900: #212121;
  --white: #fff;
}

body {
  font-family:
    Inclusive Sans,
    Arial,
    Helvetica,
    sans-serif;
  color: var(--gray-900);
  background: var(--gray-100);
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px 40px;
}

h1,
button {
  line-height: 1;
}

button {
  padding: 10px;
  font-weight: bold;
  cursor: pointer;
}

main {
  padding: 20px 40px 80px;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.gameboard-container {
  display: flex;
  gap: 40px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.ship-grid,
.attack-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  width: 402px;
  border: 1px solid var(--gray-900);
}

.attack-grid.block::before {
  content: "";
  position: absolute;
  width: 400px;
  height: 400px;
}

.ship,
.sea {
  width: 40px;
  height: 40px;
  border: 1px solid var(--gray-900);
}

.ship {
  background: var(--gray-400);
}

.sea {
  background: var(--blue-400);
}

.ship.hit,
.sea.hit {
  background: var(--red-400);
}

.sea.miss {
  background: var(--white);
}

.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;EACE,6BAA6B;EAC7B;;0DAE+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;0DAE4D;EAC5D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;CAGC;;AAED;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;;;cAIY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Fonts */\n\n@font-face {\n  font-family: \"Inclusive Sans\";\n  src:\n    url(\"assets/fonts/InclusiveSans-Regular.woff2\") format(\"woff2\"),\n    url(\"assets/fonts/InclusiveSans-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Inclusive Sans\";\n  src:\n    url(\"assets/fonts/InclusiveSans-Bold.woff2\") format(\"woff2\"),\n    url(\"assets/fonts/InclusiveSans-Bold.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/* Battleship */\n\n:root {\n  --red-400: #ef5350;\n  --blue-400: #42a5f5;\n  --gray-100: #f5f5f5;\n  --gray-400: #bdbdbd;\n  --gray-900: #212121;\n  --white: #fff;\n}\n\nbody {\n  font-family:\n    Inclusive Sans,\n    Arial,\n    Helvetica,\n    sans-serif;\n  color: var(--gray-900);\n  background: var(--gray-100);\n}\n\nheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 20px 40px;\n}\n\nh1,\nbutton {\n  line-height: 1;\n}\n\nbutton {\n  padding: 10px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\nmain {\n  padding: 20px 40px 80px;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.gameboard-container {\n  display: flex;\n  gap: 40px;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.ship-grid,\n.attack-grid {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  width: 402px;\n  border: 1px solid var(--gray-900);\n}\n\n.attack-grid.block::before {\n  content: \"\";\n  position: absolute;\n  width: 400px;\n  height: 400px;\n}\n\n.ship,\n.sea {\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--gray-900);\n}\n\n.ship {\n  background: var(--gray-400);\n}\n\n.sea {\n  background: var(--blue-400);\n}\n\n.ship.hit,\n.sea.hit {\n  background: var(--red-400);\n}\n\n.sea.miss {\n  background: var(--white);\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
